import { Injectable } from '@angular/core';
import { Global } from 'src/global';
import { SeguridadService } from './seguridad.service';
import { GrupoAcceso, GrupoAccesoModulo } from '../models/seguridad/grupo_acceso.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
    currentUser: any;
    grupoAcceso: GrupoAcceso;
    routerLinkBase: string = '/pages';
    icon = 'pi pi-fw pi-circle-fill';

    constructor(public seguridad: SeguridadService) { }
    
    ngOnInit(): void { }
    
    async getMenu() {
        this.currentUser = this.seguridad.getCurrentUser();
        this.grupoAcceso = new GrupoAcceso();
        await this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
        
        const menuRouterLink = `${ this.routerLinkBase }/home`;
        const items: Record<string, any>[] = [
            { label: 'Inicio', icon: this.icon, routerLink: [`${menuRouterLink}/dashboard`] },
        ];
        if ( await this.seguridad.tienePermisoEspecial('portal_pagos') ) {
            items.push({ label: 'Portal de Pagos', icon: this.icon, routerLink: [`${menuRouterLink}/portal`] })
        }
        const menu: Record<string, any>[] = [ { label: 'Inicio', icon: 'pi pi-fw pi-home', routerLink: [menuRouterLink], items: items } ];
        if ( this.grupoAcceso.accesoTotal ) {
            menu.push( await this.getMenuConfiguracion( this.grupoAcceso.accesoTotal ) );
            menu.push( await this.getMenuAdministracion( this.grupoAcceso.accesoTotal ));
            menu.push( await this.getMenuCobranza( this.grupoAcceso.accesoTotal ));
            menu.push( await this.getMenuSeguridad( this.grupoAcceso.accesoTotal ) );

        } else {
            // modulos activos
            for (const modulo of this.grupoAcceso.modulos) {
                const mod = new GrupoAccesoModulo();
                await mod.cargarObjeto(modulo);
                if ( mod.activo ) {
                    switch (mod.codigo) {
                        case Global.MENU.configuracion.codigo:
                            menu.push( await this.getMenuConfiguracion(mod.accesoTotal) );
                            break;
                        case Global.MENU.administracion.codigo:
                            menu.push( await this.getMenuAdministracion(mod.accesoTotal) );
                            break;
                        case Global.MENU.cobranza.codigo:
                            menu.push( await this.getMenuCobranza(mod.accesoTotal) );
                            break;
                        case Global.MENU.seguridad.codigo:
                            menu.push( await this.getMenuSeguridad(mod.accesoTotal) );
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return menu;
    }


    async getMenuConfiguracion( accesoTotal: boolean ) {

        const modulo = Global.MENU.configuracion
        const menuRouterLink = `${ this.routerLinkBase }/${ modulo.routerLink }`;
        let menu: Record<string, any> = {
            label: modulo.nombre, icon: 'pi pi-fw pi-cog', routerLink: [menuRouterLink],
            items: []
        }
        
        menu = await this.cargarRegistros( accesoTotal, modulo, menuRouterLink, menu );
        menu = await this.cargarReportes( accesoTotal, modulo, `${menuRouterLink}/reportes`, menu );

        return menu;
    }

    async getMenuAdministracion( accesoTotal: boolean ) {

        const modulo = Global.MENU.administracion;
        const menuRouterLink = `${ this.routerLinkBase }/${ modulo.routerLink }`;
        let menu: Record<string, any> = {
            label: modulo.nombre, icon: 'pi pi-fw pi-building', routerLink: [menuRouterLink],
            items: []
        }

        menu = await this.cargarRegistros( accesoTotal, modulo, menuRouterLink, menu);
        menu = await this.cargarReportes( accesoTotal, modulo, `${menuRouterLink}/reportes`, menu );

        return menu;
    }

    async getMenuCobranza( accesoTotal: boolean ) {

        const modulo = Global.MENU.cobranza;
        const menuRouterLink = `${ this.routerLinkBase }/${ modulo.routerLink }`;
        let menu: Record<string, any> = {
            label: modulo.nombre, icon: 'pi pi-fw pi-money-bill', routerLink: [menuRouterLink],
            items: []
        }

        menu = await this.cargarRegistros( accesoTotal, modulo, menuRouterLink, menu);
        menu = await this.cargarReportes( accesoTotal, modulo, `${menuRouterLink}/reportes`, menu );
        menu = await this.cargarProcesos( accesoTotal, modulo, `${menuRouterLink}/procesos`, menu );

        return menu;
    }

    async getMenuSeguridad( accesoTotal: boolean ) {

        const modulo = Global.MENU.seguridad;
        const menuRouterLink = `${ this.routerLinkBase }/${ modulo.routerLink }`;
        let menu: Record<string, any> = {
            label: modulo.nombre, icon: 'pi pi-fw pi-shield', routerLink: [menuRouterLink],
            items: []
        }
        
        menu = await this.cargarRegistros( accesoTotal, modulo, menuRouterLink, menu );

        return menu;
    }


    private async cargarRegistros( accesoTotal: boolean, modulo: Record<string, any>, menuRouterLink: string, menu: Record<string, any> ) {
        if ( accesoTotal ) {
            for (const obj of Object.keys(modulo.registros) ) {
                const registro = modulo.registros[obj]
                menu.items.push( {label: registro.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${ registro.routerLink }`]} )
            }
        } else {
            for (const registro of this.grupoAcceso.registros.filter( reg => reg.modulo === modulo.codigo) ) { 
                if ( registro.ver ) {
                    const reg = modulo.registros[registro.codigo];
                    menu.items.push( {label: reg.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${ reg.routerLink }`]} )
                }
            }
        }

        return menu;
    }

    private async cargarReportes( accesoTotal: boolean, modulo: Record<string,any>, menuRouterLink: string, menu: Record<string,any>) {
        const reportes = [];
        if ( accesoTotal ) {
            for( const obj of Object.keys(modulo.reportes) ) {
                const reporte = modulo.reportes[obj];
                reportes.push( { label: reporte.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${reporte.routerLink}`] } );
            }
        } else {
            for (const reporte of this.grupoAcceso.reportes.filter( reg => (reg.modulo === modulo.codigo && reg.activo === true) )  ) {
                const reg = modulo.reportes[reporte.codigo];
                if ( reporte.activo ) {
                    reportes.push( { label: reg.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${reg.routerLink}`] } );
                }
            }
        }
        if ( reportes.length ) menu.items.push( { label: 'Reportes', icon: 'pi pi-fw pi-book', items: reportes } );
        return menu
    }

    private async cargarProcesos( accesoTotal: boolean, modulo: Record<string,any>, menuRouterLink: string, menu: Record<string,any>) {
        const procesos = [];
        if ( accesoTotal ) {
            for( const obj of Object.keys(modulo.procesos) ) {
                const proceso = modulo.procesos[obj];
                procesos.push( { label: proceso.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${proceso.routerLink}`] } );
            }
        } else {
            for (const permiso of this.grupoAcceso.permisos.filter( rep => (rep.activo === true) ) ) {
                if ( permiso.activo ) {
                    const codigoProceso = Object.keys(modulo.procesos).find( (codigo: string) => codigo === permiso.codigo )
                    if ( codigoProceso ) {
                        const proceso = modulo.procesos[codigoProceso]
                        procesos.push( { label: proceso.nombre, icon: this.icon, routerLink: [`${menuRouterLink}/${proceso.routerLink}`] } );
                    }
                }
            }
        }
        
        if ( procesos.length ) menu.items.push( { label: 'Procesos', icon: 'pi pi-fw pi-cog', items: procesos } );
        return menu
    }
}
